var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQaAddGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186 186",
    style: {
      enableBackground: "new 0 0 186 186"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1201",
    x: 0,
    y: 0,
    width: 186,
    height: 186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#A2A2A2;}\r\n\t.st2{fill:none;stroke:#A2A2A2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qa-add-member_00000004525309374973629310000003069740401276184196_",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12)",
    filter: "url(#Rectangle_1201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201-2",
    "data-name": "Rectangle 1201",
    width: 150,
    height: 150,
    rx: 25,
    transform: "translate(12 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Add_team_member_-_large_00000054239211043281731710000014233008398002543028_",
    transform: "translate(48.07 24.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990_00000075149304203887696820000003813417291437687430_",
    transform: "translate(-1620.513 -215.418)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_320_00000163040617920947062060000010414280857007308221_",
    className: "st1",
    x1: 1685.4,
    y1: 215.4,
    x2: 1685.4,
    y2: 239.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321_00000003086901832475496340000009250705437893316248_",
    className: "st1",
    x1: 1697.2,
    y1: 227.3,
    x2: 1673.5,
    y2: 227.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1991_00000147914595997768270730000012121942855107350151_",
    transform: "translate(-1545.5 87.806)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5_00000149366465739391063540000013571151457148296086_",
    className: "st2",
    cx: 1583.1,
    cy: -49.2,
    r: 12.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167_00000006699458204892299420000013122436395068123564_",
    className: "st2",
    d: "M1554.4-4.8L1554.4-4.8 c0-13.7,11.1-24.7,24.7-24.7l0,0h7.4c13.7,0,24.7,11.1,24.7,24.7l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168_00000049208271468201111320000004796263120363800765_",
    className: "st2",
    d: "M1560.5-51.8c0,4.7-3.9,8.6-8.6,8.6 c-4.7,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6l0,0C1556.6-60.4,1560.5-56.6,1560.5-51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169_00000121242691810872207590000000573486069420152707_",
    className: "st2",
    d: "M1532.1-20.9L1532.1-20.9 c0-9.5,7.7-17.2,17.2-17.2h5.2c4.6,0,9,1.8,12.2,5.1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaAddGroup);
export default __webpack_public_path__ + "static/media/qa-add-group.91fb1ec0a8546c88d7aba58343575ea9.svg";
export { ForwardRef as ReactComponent };